import { useCallback, useState } from 'react';

import _ from 'lodash';
import API from 'utils/api';
import useSources from './useSources';

const useMessageSender = props => {
  const [filter, setFilter] = useState({});

  const event = _.get(props, '_id');
  const channel = _.get(props, 'channel._id');
  const awayTeam = _.get(props, 'game.away._id');
  const homeTeam = _.get(props, 'game.home._id');

  const sources = useSources();

  const sendMessage = useCallback(
    (type, body, extras) =>
      API.sendMessage(
        { type, channel, event, body, awayTeam, homeTeam, ...filter, ...extras },
        sources
      ),
    [channel, event, filter, sources]
  );

  return { sendMessage, setFilter };
};

export default useMessageSender;
